import { render, staticRenderFns } from "./Invitation_Friend.vue?vue&type=template&id=5dc11bd1&scoped=true"
import script from "./Invitation_Friend.vue?vue&type=script&lang=js"
export * from "./Invitation_Friend.vue?vue&type=script&lang=js"
import style0 from "./Invitation_Friend.vue?vue&type=style&index=0&id=5dc11bd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc11bd1",
  null
  
)

export default component.exports